<template>
 <div  v-if="isLoading" class="calculation-spinner flex flex-center">
    <q-spinner-facebook size="3em" color="primary" />
</div>
<div v-else>
      <div v-if="selectedObject && selectedObject.length ===0" class="text-deep-black-4 font-weight-normal mt-3">
          <span>  {{ $t("order.orderActions.NoDocumentsFound") }}  </span>
      </div> 
       <div v-if="selectedObject && selectedObject.length" class="row">
      <div  class="col-12">
          <div class="card-body pl-2 pr-2 pt-1 pb-0 mb-2">
                <div >
                    <div class="tw-dashed-border-secondary custom-border mt-2" v-for="(value, index) in selectedObject" :key="index">
                        <div class="row mt-2 mb-2" v-if="value"> 
                            
                                  <div  class="col-lg-4 d-flex flex-column">
                                      <label class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.type') }}
                                      </label>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                          {{ documentType(value) }}
                                        </a>
                                      </span>
                                </div>
                                 <div  class="col-lg-2 d-flex flex-column">
                                      <label class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.date') }}
                                      </label>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                          {{ getDateFormat(value._when_created) }}
                                        </a>
                                      </span>
                                </div>
                                 <div  class="col-lg-3 d-flex flex-column">
                                      <label class="d-block mb-0 ml-3 text-muted">
                                        {{ $t('demand.documents.columns.user')  }}
                                      </label>
                                      <span class="ml-3">
                                        <a class="cursor-pointer tw-ellipses-text">
                                           {{ value._who_created }}
                                        </a>
                                      </span>
                                </div>

                                <div class="col-lg-3 text-right" >
                              

                                  <q-btn v-if="value" outline class="btn btn-action"
                                      style="margin-right: 0.2em;"
                                        icon="visibility"
                                        @click="viewDocument(value)">
                                  </q-btn>

                                  <q-btn v-if="value" outline class="btn btn-action"
                                      style="margin-right: 0.2em;"
                                        icon="download"
                                        @click="downloadDocument(value)">
                                  </q-btn>

                                  <q-btn v-if="value" 
                                      style="margin-right: 0.2em;" 
                                      outline 
                                      class="btn btn-action" 
                                      icon="print" 
                                      @click="printDocument(value)">
                                  </q-btn>
                                  
                              </div>
                          </div>
                        </div> 
                </div>
                </div>
                </div>
                </div>
 
  </div>
</template>

<script lang="ts">
import { downloadFileName } from "@/utils/download-file-name";
import {Options, Vue} from "vue-class-component";
import { openFileInNewTab } from "@/commons/index";
import moment from "moment";
import store from "@/store";

@Options({
  methods: {},
  components: {},
  props: [""],
})
export default class OrderSummaryDocuments extends Vue {
 
  isLoading = true


getDateFormat(date?: any){
     return moment(date, 'YYYY-MM-DD HH:mm:ss.S').format('DD/MM/YYYY HH:mm') 
}


get selectedObject() {
       return store.state.orderModule && store.state.orderModule.deletedDocuments ? store.state.orderModule.deletedDocuments : []
}

documentType(value: any) {
    let relations : any = [];
     if (value?.relations) {
         relations = JSON.parse(value.relations);
     }
       return relations
       && relations[0]
       && relations[0].qualifier
       && relations[0].qualifier.rawValue
       ? relations[0].qualifier.rawValue
       : ""
}

async downloadDocument(document: any) {
      await store.dispatch("taskModule/uploadDocumentModule/downloadFile", {
            request: {resourceUid:document.file_resourceuid},
            callback: this.downloadDocumentResponse,
          });
}

      
downloadDocumentResponse(response: any) {
      if (response) {
          const {content} = response;
          const linkSource = `data:${response.format};base64,${content}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = downloadFileName(response);
            downloadLink.click();
      }
}

async printDocument(document: any) {
    const downloadDocument :any = await new Promise((resolve) => {
              store.dispatch("taskModule/uploadDocumentModule/downloadFile", {
                callback: (res:any) => {
                  resolve(res);
                },
                request: {resourceUid:document.file_resourceuid}
              });
          });
    if (downloadDocument.content) {
          this.printDocumentResonse(downloadDocument)
    }
}


printDocumentResonse(documentUploadResponse: any) {
    if (documentUploadResponse) {
      const {content, format} = documentUploadResponse;
      const byteCharacters = atob(content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: format});

            const blobUrl = URL.createObjectURL(blob);

            // Crée dynamiquement un iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            iframe.src = blobUrl;

            iframe.onload = function() {
                iframe?.contentWindow?.focus();
                iframe.contentWindow?.print();

            };
    }
}

async viewDocument (document: any) {
    const downloadDocument :any = await new Promise((resolve) => {
              store.dispatch("taskModule/uploadDocumentModule/downloadFile", {
                callback: (res:any) => {
                  resolve(res);
                },
                request: {resourceUid:document.file_resourceuid}
              });
    });
  if (downloadDocument.content) {
      const { format, content } = downloadDocument
      openFileInNewTab({ name: downloadDocument.originalFileName, mimeType: format, base64: content });
  } 
}


async created() {
    this.isLoading = true
    if (store.state.summaryPanelModule.order?.resourceUid) {
        await store.dispatch("orderModule/getOrderDeletedDocuments", {
            filter: {
                orderResourceUid: store.state.summaryPanelModule.order?.resourceUid
            },
        });
        this.isLoading = false
    }
    else {
      this.isLoading = false
    }
  }
}
</script>


<style scoped>
.custom-border{
  background: white;
    border: 1px dashed #3699FF;
    border-radius: 8px;
    overflow: hidden;
}

</style>
	